<!-- This is primarily used in entity pages where tabs are used and the tab content changes -->
<!-- This applies the container class and ensures that there is a minimum padding between the sides of the container -->
<template>
  <div class="sm:px-4 lg:px-8">
    <div v-bind="$attrs" class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineComponent({
  inheritAttrs: false,
});
</script>
